import { lazyLoad, ImportBundle, fixedsHeader, initSearch, globalSearch, initFancyBox } from "../common";
import Swiper from "swiper11";
import footer1_Init from "../components/footer-1";
import { Navigation, Pagination, Autoplay } from "swiper11/modules";
import { init } from "../mainEntry";
import { presetGSAP_IN, swiperGsapTimeline, YIGEAnimation } from "@common/utils/gsapUtils";
$(async function () {
  await init();
  initFunction();
});

function initFunction() {
  initFancyBox();
  ImportBundle({ type: "css", onlyIndex: true }, [
    "https://static.yigetechcms.com/public/css/swiper-bundle@11.1.1.min.css",
    "https://static.yigetechcms.com/public/css/fancybox@5.0.0.min.css",
  ]);
  lazyLoad();
  initEvent();
  initSwiper();
}

function initEvent() {
  new YIGEAnimation();
  fixedsHeader("header-1");
  initSearch(".header-search form", ".header-search .toggle");
  globalSearch();
  footer1_Init();
  $(".index-1-product-body .list .item").on("click", function () {
    $(this).addClass("active").siblings().removeClass("active");
    $(".content .item").eq($(".index-1-product-body .list .item").index(this)).addClass("actived").siblings().removeClass("actived");
  });
}

function initSwiper() {
  let index_banner = ".index-1-banner";
  new Swiper(`${index_banner} .swiper-container`, {
    modules: [Navigation, Pagination, Autoplay],
    slidesPerView: 1,
    speed: 1500,
    autoplay: {
      disableOnInteraction: false,
      delay: 5500,
    },
    loop: true,
    navigation: {
      nextEl: `${index_banner} .next`,
      prevEl: `${index_banner} .prev`,
    },
    pagination: {
      el: `${index_banner} .custom-swiper-pagination`,
      clickable: true,
    },
  });

  let index_news_banner = ".index-1-news-banner ";
  new Swiper(`${index_news_banner} .swiper-container`, {
    modules: [Navigation, Pagination, Autoplay],
    slidesPerView: 1,
    spaceBetween: 30, //间隔
    speed: 1000,
    autoplay: {
      delay: 5000,
    },
    loop: true,
    navigation: {
      nextEl: `${index_news_banner} .next`,
      prevEl: `${index_news_banner} .prev`,
    },
    pagination: {
      el: `${index_news_banner} .swiper-pagination`,
      clickable: true,
    },
  });

  let index_news_banner2 = ".index-1-news-banner2 ";
  new Swiper(`${index_news_banner2} .swiper-container`, {
    modules: [Navigation, Pagination, Autoplay],
    slidesPerView: 3,
    spaceBetween: 30,
    speed: 1000,
    watchSlidesProgress: true,
    autoplay: {
      delay: 5000,
      pauseOnMouseEnter: true,
      disableOnInteraction: false,
    },
    loop: true,
    navigation: {
      nextEl: `${index_news_banner2} .swiper-button-next`,
      prevEl: `${index_news_banner2} .swiper-button-prev`,
    },
    pagination: {
      el: `${index_news_banner2} .swiper-pagination`,
      clickable: true,
    },

    breakpoints: {
      320: {
        //当屏幕宽度大于等于320
        slidesPerView: 1,
        spaceBetween: 10,
      },
      768: {
        //当屏幕宽度大于等于768
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1024: {
        //当屏幕宽度大于等于1280
        slidesPerView: 3,
        spaceBetween: 30,
      },
    },
    on: {
      init: (swiper) => {
        const { clipInCenter, scaleInCenter, clipInUp, fadeInUp } = presetGSAP_IN({ stagger: 0.15 });
        const T = swiperGsapTimeline(swiper);
        const title = $(swiper.visibleSlides).find(".title");
        const des = $(swiper.visibleSlides).find(".text");
        const img = $(swiper.visibleSlides).find(".img-box");

        T?.from(title, clipInUp);
        T?.from(des, fadeInUp, "<");
        T?.from(img, { ...clipInCenter, ...scaleInCenter }, "<");
      },
    },
  });
}
